export function shareLinkStatus(link: { revoked_at?: string | null; expires_at?: string | null }, now = Date.now()): 'active' | 'expired' | 'revoked' | 'unknown' {
  if (link.revoked_at) return 'revoked'
  if (!link.expires_at) return 'active'
  const expiry = Date.parse(link.expires_at)
  if (!Number.isFinite(expiry)) return 'unknown'
  return expiry <= now ? 'expired' : 'active'
}
